'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { i18n, type Locale } from '../../i18n-config'
import Icon from '../ui/icons/Icon'

interface LocaleSwitcherProps {
  textColor?: string
}

export const LocaleSwitcher: React.FC<LocaleSwitcherProps> = ({
  textColor
}) => {
  const pathname = usePathname()

  const getActiveLocale = (): Locale => {
    const segments = pathname?.split('/') || []
    return segments[1] as Locale
  }

  const redirectedPathname = (locale: Locale) => {
    if (!pathname) return '/'
    const segments = pathname.split('/')
    segments[1] = locale
    return segments.join('/')
  }

  const activeLocale = getActiveLocale()

  return (
    <div className="flex border hover:bg-grey-100/10 hover:shadow rounded-full border-grey-800 pl-1.5 pr-2.5 py-1 cursor-pointer">
      {i18n.locales
        .filter(locale => locale !== activeLocale) // Filter de actieve taal eruit
        .map(locale => (
          <Link
            key={locale}
            href={redirectedPathname(locale)}
            className={`flex items-center gap-x-3 ${textColor ? `${textColor}` : 'text-white'} font-medium uppercase cursor-pointer`}
          >
            <span>
              <Icon name={locale} className="size-5" />
            </span>
            {locale}
          </Link>
        ))}
    </div>
  )
}
